import React from "react";
import { Link, useLocation } from "react-router-dom";
import { LogoMark } from "@/components/AppLayout";

const GLOSSARY_TERMS = [
  { path: "/glossary/ai-knowledge-artifact", label: "AI Knowledge Artifact" },
  { path: "/glossary/contributor-class", label: "Contributor Class" },
  { path: "/glossary/ai-knowledge-governance", label: "AI Knowledge Governance" },
];

const TOOLS = [
  { path: "/tools/policy-checker", label: "Policy Checker" },
  { path: "/tools/contributor-class-classifier", label: "Contributor Class Classifier" },
  { path: "/tools/ai-governance-maturity", label: "AI Governance Maturity" },
];

export default function GlossaryLayout({ children }) {
  const { pathname } = useLocation();

  return (
    <div className="min-h-screen bg-background text-foreground">
      {/* Top nav */}
      <header className="border-b border-border/80 sticky top-0 bg-background/95 backdrop-blur z-10">
        <div className="max-w-5xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <LogoMark />
            <span className="font-serif-display text-lg">ProofMark</span>
          </Link>
          <div className="flex items-center gap-5">
            <Link
              to="/tools"
              className="text-sm text-muted-foreground hover:text-foreground transition-colors"
            >
              Free tools
            </Link>
            <Link
              to="/app"
              className="bg-brand text-brand-foreground text-sm px-3.5 py-1.5 rounded-md hover:opacity-90 transition-opacity"
            >
              Open app →
            </Link>
          </div>
        </div>
      </header>

      {/* Main content */}
      <main className="max-w-5xl mx-auto px-6 py-12">{children}</main>

      {/* Footer */}
      <footer className="border-t border-border/80 mt-16 bg-muted/30">
        <div className="max-w-5xl mx-auto px-6 py-10 grid md:grid-cols-2 gap-10">
          <div>
            <p className="tracked-caps mb-4">AI Governance Glossary</p>
            <div className="space-y-2">
              {GLOSSARY_TERMS.filter((t) => t.path !== pathname).map((t) => (
                <div key={t.path}>
                  <Link
                    to={t.path}
                    className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                  >
                    {t.label} →
                  </Link>
                </div>
              ))}
            </div>
          </div>
          <div>
            <p className="tracked-caps mb-4">Free tools</p>
            <div className="space-y-2">
              {TOOLS.map((t) => (
                <div key={t.path}>
                  <Link
                    to={t.path}
                    className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                  >
                    {t.label} →
                  </Link>
                </div>
              ))}
              <div>
                <Link
                  to="/blog"
                  className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                >
                  Blog →
                </Link>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
